module.exports = __webpack_public_path__ + "static/ilowo_osada-48cf062405527ec7ee089ea166669101.png";